/* eslint camelcase: 0 */
// import en from './en';
import fr from './fr';
import fr_CH from './fr_CH';
import fr_MU from './fr_MU';

export default {
  // en,
  fr,
  fr_CH,
  fr_MU,
};
